/**
 * Created by Owner on 2016/10/14.
 */
export const CityUtil = {
  "1": {"1": "北京市"},
  "6": {
    "18": "大同市",
    "180": "太原市",
    "182": "阳泉市",
    "183": "长治市",
    "184": "晋城市",
    "185": "朔州市",
    "186": "古交市",
    "187": "忻州市",
    "189": "临汾市",
    "191": "霍州市",
    "192": "运城市",
    "205": "潞城市",
    "209": "高平市",
    "228": "原平市",
    "242": "介休市",
    "251": "汾阳市",
    "254": "孝义市",
    "276": "河津市",
    "277": "永济市",
    "2314": "侯马市",
    "2601": "晋中市",
    "2643": "吕梁市"
  },
  "2": {"19": "上海市"},
  "3": {"40": "天津市"},
  "4": {"58": "重庆市"},
  "5": {
    "99": "呼和浩特市",
    "100": "包头市",
    "101": "乌海市",
    "102": "赤峰市",
    "104": "丰镇市",
    "105": "锡林浩特市",
    "106": "二连浩特市",
    "108": "满州里市",
    "109": "牙克石市",
    "110": "扎兰屯市",
    "111": "通辽市",
    "112": "霍林郭勒市",
    "2346": "乌兰浩特市",
    "2626": "鄂尔多斯市",
    "2627": "呼伦贝尔市",
    "2628": "巴彦淖尔市",
    "2629": "乌兰察布市",
    "2630": "兴安盟",
    "2631": "锡林郭勒盟",
    "2632": "阿拉善盟",
    "2633": "根河市",
    "2634": "额尔古纳市",
    "2635": "阿尔山市"
  },
  "7": {
    "284": "石家庄市",
    "285": "邯郸市",
    "286": "邢台市",
    "287": "保定市",
    "288": "张家口市",
    "289": "承德市",
    "290": "唐山市",
    "291": "秦皇岛市",
    "292": "沧州市",
    "293": "廊坊市",
    "294": "武安市",
    "295": "霸州市",
    "296": "泊头市",
    "297": "任丘市",
    "298": "黄骅市",
    "299": "河间市",
    "300": "衡水市",
    "312": "迁安市",
    "317": "遵化市",
    "327": "三河市",
    "2234": "定州市",
    "2235": "安国市",
    "2240": "涿州市",
    "2241": "高碑店市",
    "2253": "辛集市",
    "2254": "晋州市",
    "2255": "藁城市",
    "2256": "新乐市",
    "2257": "鹿泉市",
    "2268": "沙河市",
    "2271": "南宫市",
    "2277": "冀州市",
    "2278": "深州市"
  },
  "8": {
    "352": "沈阳市",
    "353": "大连市",
    "354": "鞍山市",
    "355": "抚顺市",
    "356": "本溪市",
    "357": "丹东市",
    "358": "锦州市",
    "359": "葫芦岛市",
    "360": "营口市",
    "361": "阜新市",
    "362": "辽阳市",
    "363": "铁岭市",
    "364": "朝阳市",
    "365": "瓦房店市",
    "366": "海城市",
    "367": "兴城市",
    "368": "调兵山市",
    "369": "北票市",
    "370": "开原市",
    "371": "新民市",
    "374": "庄河市",
    "384": "凤城市",
    "389": "北镇市",
    "397": "灯塔市",
    "404": "凌源市",
    "2207": "盘锦市",
    "2347": "盖州市",
    "2351": "东港市",
    "2534": "普兰店市",
    "2535": "凌海市",
    "2625": "大石桥市"
  },
  "9": {
    "407": "长春市",
    "408": "吉林市",
    "409": "四平市",
    "410": "辽源市",
    "411": "通化市",
    "413": "公主岭市",
    "414": "梅河口市",
    "415": "集安市",
    "416": "九台市",
    "417": "桦甸市",
    "418": "蛟河市",
    "419": "榆树市",
    "420": "白城市",
    "421": "洮南市",
    "423": "大安市",
    "424": "延吉市",
    "425": "图们市",
    "426": "敦化市",
    "427": "龙井市",
    "428": "珲春市",
    "431": "德惠市",
    "433": "磐石市",
    "434": "舒兰市",
    "436": "双辽市",
    "453": "和龙市",
    "2352": "白山市",
    "2353": "松原市",
    "2354": "临江市",
    "2623": "延边朝鲜族自治州"
  },
  "10": {
    "454": "哈尔滨市",
    "455": "齐齐哈尔市",
    "456": "鹤岗市",
    "457": "双鸭山市",
    "458": "鸡西市",
    "459": "大庆市",
    "460": "伊春市",
    "461": "牡丹江市",
    "462": "佳木斯市",
    "463": "七台河市",
    "464": "绥芬河市",
    "466": "同江市",
    "467": "富锦市",
    "468": "铁力市",
    "469": "密山市",
    "470": "绥化市",
    "471": "安达市",
    "472": "肇东市",
    "473": "海伦市",
    "474": "黑河市",
    "475": "北安市",
    "476": "五大连池市",
    "477": "尚志市",
    "478": "双城市",
    "483": "讷河市",
    "499": "海林市",
    "500": "穆棱市",
    "501": "虎林市",
    "502": "宁安市",
    "528": "五常市",
    "534": "大兴安岭地区"
  },
  "11": {
    "535": "南京市",
    "536": "徐州市",
    "537": "连云港市",
    "539": "盐城市",
    "540": "扬州市",
    "541": "南通市",
    "542": "镇江市",
    "544": "常州市",
    "545": "无锡市",
    "546": "苏州市",
    "547": "泰州市",
    "548": "仪征市",
    "549": "常熟市",
    "550": "张家港市",
    "551": "江阴市",
    "552": "宿迁市",
    "553": "丹阳市",
    "554": "东台市",
    "555": "兴化市",
    "556": "淮安市",
    "557": "宜兴市",
    "558": "昆山市",
    "559": "启东市",
    "560": "新沂市",
    "561": "溧阳市",
    "589": "大丰市",
    "592": "泰兴市",
    "594": "江都市",
    "595": "靖江市",
    "596": "高邮市",
    "598": "如皋市",
    "600": "海门市",
    "603": "句容市",
    "604": "扬中市",
    "606": "金坛市",
    "609": "吴江市",
    "610": "太仓市",
    "2211": "通州市",
    "2359": "邳州市",
    "2624": "姜堰市"
  },
  "12": {
    "611": "合肥市",
    "612": "淮南市",
    "613": "淮北市",
    "614": "芜湖市",
    "615": "铜陵市",
    "616": "蚌埠市",
    "617": "马鞍山市",
    "618": "安庆市",
    "619": "黄山市",
    "620": "宿州市",
    "621": "滁州市",
    "622": "巢湖市",
    "626": "六安市",
    "627": "阜阳市",
    "628": "毫州市",
    "629": "界首市",
    "643": "桐城市",
    "663": "天长市",
    "671": "宁国市",
    "2366": "明光市",
    "2368": "宣城市",
    "2602": "池州市"
  },
  "13": {
    "692": "济南市",
    "693": "青岛市",
    "694": "淄博市",
    "695": "枣庄市",
    "696": "东营市",
    "698": "烟台市",
    "699": "威海市",
    "700": "济宁市",
    "701": "泰安市",
    "702": "日照市",
    "703": "青州市",
    "704": "龙口市",
    "705": "曲阜市",
    "706": "莱芜市",
    "707": "新泰市",
    "708": "胶州市",
    "709": "诸城市",
    "710": "莱阳市",
    "711": "莱州市",
    "712": "滕州市",
    "713": "文登市",
    "714": "荣成市",
    "715": "即墨市",
    "716": "平度市",
    "717": "莱西市",
    "718": "胶南市",
    "719": "德州市",
    "720": "乐陵市",
    "721": "滨州市",
    "722": "临沂市",
    "724": "聊城市",
    "725": "临清市",
    "726": "章丘市",
    "737": "昌邑市",
    "739": "高密市",
    "742": "安丘市",
    "743": "寿光市",
    "745": "招远市",
    "746": "栖霞市",
    "747": "海阳市",
    "748": "蓬莱市",
    "750": "乳山市",
    "751": "兖州市",
    "762": "肥城市",
    "766": "禹城市",
    "2208": "潍坊市",
    "2209": "菏泽市",
    "2396": "邹城市"
  },
  "14": {
    "802": "杭州市",
    "803": "宁波市",
    "804": "温州市",
    "805": "嘉兴市",
    "806": "湖州市",
    "807": "绍兴市",
    "808": "金华市",
    "809": "衢州市",
    "810": "舟山市",
    "811": "余姚市",
    "812": "海宁市",
    "813": "兰溪市",
    "814": "瑞安市",
    "816": "江山市",
    "818": "东阳市",
    "819": "义乌市",
    "820": "慈溪市",
    "821": "奉化市",
    "822": "诸暨市",
    "824": "临海市",
    "826": "丽水市",
    "827": "龙泉市",
    "829": "临安市",
    "831": "富阳市",
    "832": "建德市",
    "843": "乐清市",
    "846": "平湖市",
    "848": "桐乡市",
    "855": "上虞市",
    "858": "永康市",
    "869": "温岭市",
    "2216": "台州市",
    "2361": "嵊州市"
  },
  "15": {
    "879": "南昌市",
    "880": "景德镇市",
    "881": "萍乡市",
    "882": "新余市",
    "883": "九江市",
    "884": "鹰潭市",
    "885": "瑞昌市",
    "886": "上饶市",
    "887": "德兴市",
    "888": "宜春市",
    "889": "丰城市",
    "890": "樟树市",
    "892": "吉安市",
    "894": "赣州市",
    "899": "乐平市",
    "911": "贵溪市",
    "925": "高安市",
    "957": "南康市",
    "964": "瑞金市",
    "2376": "井冈山市",
    "2377": "抚州市"
  },
  "16": {
    "969": "福州市",
    "970": "厦门市",
    "971": "三明市",
    "972": "莆田市",
    "973": "泉州市",
    "974": "漳州市",
    "975": "永安市",
    "976": "石狮市",
    "977": "福清市",
    "978": "南平市",
    "979": "邵武市",
    "980": "武夷山市",
    "981": "宁德市",
    "982": "福安市",
    "983": "龙岩市",
    "984": "漳平市",
    "991": "长乐市",
    "1007": "南安市",
    "1008": "晋江市",
    "1011": "龙海市",
    "1020": "建阳市",
    "1023": "建瓯市",
    "1032": "福鼎市"
  },
  "17": {
    "1040": "长沙市",
    "1041": "株洲市",
    "1042": "湘潭市",
    "1043": "衡阳市",
    "1044": "岳阳市",
    "1045": "常德市",
    "1046": "张家界市",
    "1047": "醴陵市",
    "1048": "湘乡市",
    "1051": "津市市",
    "1052": "韶山市",
    "1053": "郴州市",
    "1054": "资兴市",
    "1055": "永州市",
    "1057": "娄底市",
    "1058": "冷水江市",
    "1059": "涟源市",
    "1060": "怀化市",
    "1061": "洪江市",
    "1062": "益阳市",
    "1063": "沅江市",
    "1064": "吉首市",
    "1068": "浏阳市",
    "1076": "武冈市",
    "1080": "邵阳市",
    "1086": "临湘市",
    "2416": "耒阳市",
    "2421": "常宁市",
    "2621": "湘西土家族苗族自治州",
    "2622": "汨罗市"
  },
  "18": {
    "1138": "武汉市",
    "1139": "黄石市",
    "1140": "襄樊市",
    "1142": "荆州市",
    "1144": "荆门市",
    "1145": "鄂州市",
    "1146": "随州市",
    "1147": "老河口市",
    "1148": "枣阳市",
    "1149": "孝感市",
    "1150": "应城市",
    "1151": "安陆市",
    "1152": "广水市",
    "1153": "麻城市",
    "1154": "武穴市",
    "1156": "咸宁市",
    "1158": "仙桃市",
    "1159": "石首市",
    "1160": "天门市",
    "1161": "洪湖市",
    "1162": "潜江市",
    "1163": "宜昌市",
    "1165": "当阳市",
    "1166": "十堰市",
    "1167": "丹江口市",
    "1168": "恩施市",
    "1169": "利川市",
    "1180": "神农架林区",
    "1181": "汉川市",
    "1197": "钟祥市",
    "1201": "松滋市",
    "1206": "枝江市",
    "2410": "大冶市",
    "2412": "黄冈市",
    "2618": "恩施土家族苗族自治州",
    "2619": "宜都市",
    "2620": "赤壁市"
  },
  "19": {
    "1220": "郑州市",
    "1221": "开封市",
    "1222": "洛阳市",
    "1223": "平顶山市",
    "1224": "焦作市",
    "1225": "鹤壁市",
    "1226": "新乡市",
    "1227": "安阳市",
    "1228": "濮阳市",
    "1229": "许昌市",
    "1230": "漯河市",
    "1231": "三门峡市",
    "1232": "义马市",
    "1233": "汝州市",
    "1234": "济源市",
    "1235": "禹州市",
    "1236": "卫辉市",
    "1237": "辉县市",
    "1238": "沁阳市",
    "1239": "舞钢市",
    "1240": "商丘市",
    "1241": "周口市",
    "1242": "驻马店市",
    "1243": "信阳市",
    "1244": "南阳市",
    "1245": "邓州市",
    "1246": "荥阳市",
    "1247": "登封市",
    "1249": "新郑市",
    "1260": "偃师市",
    "1295": "长葛市",
    "1300": "灵宝市",
    "1308": "永城市",
    "1320": "项城市",
    "2398": "巩义市",
    "2403": "林州市",
    "2616": "新密市",
    "2617": "孟州市"
  },
  "20": {
    "1350": "广州市",
    "1351": "深圳市",
    "1352": "珠海市",
    "1353": "汕头市",
    "1354": "韶关市",
    "1355": "河源市",
    "1356": "梅州市",
    "1357": "惠州市",
    "1358": "汕尾市",
    "1359": "东莞市",
    "1360": "中山市",
    "1361": "江门市",
    "1362": "佛山市",
    "1363": "阳江市",
    "1364": "湛江市",
    "1365": "茂名市",
    "1366": "肇庆市",
    "1367": "清远市",
    "1368": "潮州市",
    "1370": "从化市",
    "1371": "增城市",
    "1382": "揭阳市",
    "1384": "南雄市",
    "1389": "乐昌市",
    "1400": "兴宁市",
    "1408": "陆丰市",
    "1410": "台山市",
    "1411": "开平市",
    "1412": "恩平市",
    "1413": "鹤山市",
    "1419": "阳春市",
    "1420": "吴川市",
    "1424": "廉江市",
    "1425": "高州市",
    "1426": "信宜市",
    "1428": "化州市",
    "1429": "高要市",
    "1431": "四会市",
    "1433": "罗定市",
    "1434": "云浮市",
    "1439": "英德市",
    "2425": "连州市",
    "2428": "普宁市",
    "2607": "雷州市"
  },
  "21": {
    "1446": "海口市",
    "1447": "三亚市",
    "1448": "五指山市",
    "1450": "文昌市",
    "1451": "琼海市",
    "1452": "万宁市",
    "1460": "东方市",
    "2615": "儋州市"
  },
  "22": {
    "1465": "南宁市",
    "1466": "柳州市",
    "1467": "桂林市",
    "1468": "梧州市",
    "1469": "北海市",
    "1470": "凭祥市",
    "1471": "合山市",
    "1472": "玉林市",
    "1473": "贵港市",
    "1474": "百色市",
    "1475": "河池市",
    "1488": "崇左市",
    "1497": "来宾市",
    "1515": "岑溪市",
    "1517": "贺州市",
    "1521": "桂平市",
    "1522": "北流市",
    "2430": "钦州市",
    "2435": "防城港市",
    "2608": "宜州市",
    "2609": "东兴市"
  },
  "23": {
    "1546": "贵阳市",
    "1547": "六盘水市",
    "1548": "遵义市",
    "1549": "赤水市",
    "1550": "铜仁市",
    "1552": "安顺市",
    "1553": "兴义市",
    "1554": "凯里市",
    "1555": "都匀市",
    "1563": "仁怀市",
    "1581": "毕节市",
    "1594": "清镇市",
    "1627": "福泉市",
    "2610": "黔西南布依族苗族自治州",
    "2611": "黔东南苗族侗族自治州",
    "2612": "黔南布依族苗族自治州",
    "2613": "铜仁地区",
    "2614": "毕节地区"
  },
  "24": {
    "1631": "成都市",
    "1632": "自贡市",
    "1633": "攀枝花市",
    "1634": "泸州市",
    "1635": "德阳市",
    "1636": "绵阳市",
    "1637": "广元市",
    "1638": "遂宁市",
    "1639": "内江市",
    "1640": "乐山市",
    "1641": "南充市",
    "1642": "宜宾市",
    "1643": "广安市",
    "1644": "广汉市",
    "1645": "西昌市",
    "1646": "江油市",
    "1647": "彭州市",
    "1648": "崇州市",
    "1649": "都江堰市",
    "1651": "巴中市",
    "1652": "雅安市",
    "1653": "眉山市",
    "1654": "阿坝藏族羌族自治州",
    "1655": "甘孜藏族自治州",
    "1656": "凉山彝族自治州",
    "2452": "邛崃市",
    "2459": "峨眉山市",
    "2467": "简阳市",
    "2472": "绵竹市",
    "2473": "什邡市",
    "2489": "资阳市",
    "2645": "达州市",
    "2646": "阆中市",
    "2647": "华蓥市",
    "2648": "万源市"
  },
  "25": {
    "1659": "昆明市",
    "1661": "昭通市",
    "1662": "曲靖市",
    "1663": "玉溪市",
    "1664": "保山市",
    "1665": "个旧市",
    "1666": "开远市",
    "1667": "楚雄市",
    "1668": "大理市",
    "1675": "安宁市",
    "1688": "宣威市",
    "1706": "普洱市",
    "1714": "临沧市",
    "1728": "丽江市",
    "1749": "景洪市",
    "1772": "潞西市",
    "1775": "瑞丽市",
    "2670": "西双版纳傣族自治州",
    "2671": "德宏傣族景颇族自治州",
    "2672": "怒江傈僳族自治州",
    "2673": "迪庆藏族自治州",
    "2674": "文山壮族苗族自治州",
    "2675": "红河哈尼族彝族自治州",
    "2676": "楚雄彝族自治州",
    "2677": "大理白族自治州"
  },
  "26": {
    "1785": "西安市",
    "1787": "宝鸡市",
    "1788": "咸阳市",
    "1789": "榆林市",
    "1790": "延安市",
    "1791": "渭南市",
    "1792": "韩城市",
    "1793": "华阴市",
    "1795": "安康市",
    "1796": "汉中市",
    "1820": "兴平市",
    "2505": "铜川市",
    "2644": "商洛市"
  },
  "27": {
    "1882": "兰州市",
    "1883": "金昌市",
    "1884": "白银市",
    "1885": "天水市",
    "1886": "嘉峪关市",
    "1887": "平凉市",
    "1889": "武威市",
    "1890": "张掖市",
    "1891": "玉门市",
    "1892": "酒泉市",
    "1894": "临夏市",
    "1907": "定西市",
    "1920": "庆阳市",
    "2603": "陇南市",
    "2604": "临夏回族自治州",
    "2605": "甘南藏族自治州",
    "2606": "合作市",
    "2678": "敦煌市"
  },
  "28": {"1964": "银川市", "1965": "石嘴山市", "1966": "吴忠市", "1967": "青铜峡市", "1975": "灵武市", "1976": "中卫市", "1978": "固原市"},
  "29": {
    "1984": "西宁市",
    "1985": "格尔木市",
    "1986": "德令哈市",
    "1988": "海东地区",
    "2636": "海北藏族自治州",
    "2637": "黄南藏族自治州",
    "2638": "海南藏族自治州",
    "2639": "果洛藏族自治州",
    "2640": "玉树藏族自治州",
    "2641": "海西蒙古族藏族自治州",
    "2642": "冷湖行委"
  },
  "30": {
    "2026": "乌鲁木齐市",
    "2027": "克拉玛依市",
    "2028": "石河子市",
    "2029": "吐鲁番市",
    "2030": "哈密市",
    "2031": "和田市",
    "2032": "阿克苏市",
    "2033": "喀什市",
    "2034": "阿图什市",
    "2035": "库尔勒市",
    "2036": "昌吉市",
    "2037": "博乐市",
    "2039": "伊宁市",
    "2040": "塔城市",
    "2041": "阿勒泰市",
    "2085": "阜康市",
    "2104": "乌苏市",
    "2519": "奎屯市",
    "2520": "五家渠市",
    "2525": "阿拉尔市",
    "2655": "博尔塔拉蒙古自治州",
    "2656": "巴音郭楞蒙古自治州",
    "2657": "克孜勒苏柯尔克孜自治州",
    "2658": "伊犁哈萨克自治州",
    "2659": "图木舒克市",
    "2660": "吐鲁番地区",
    "2661": "哈密地区",
    "2662": "和田地区",
    "2663": "阿克苏地区",
    "2664": "喀什地区",
    "2665": "昌吉回族自治州",
    "2666": "塔城地区",
    "2667": "阿勒泰地区",
    "2668": "吐鲁番地区",
    "2669": "博乐市"
  },
  "31": {
    "2114": "拉萨市",
    "2115": "日喀则市",
    "2123": "那曲县",
    "2133": "昌都县",
    "2186": "林芝县",
    "2527": "山南地区",
    "2649": "阿里地区",
    "2650": "林芝地区",
    "2652": "日喀则地区",
    "2653": "那曲地区",
    "2654": "昌都地区"
  },
  "32": {"2530": "香港地区"},
  "33": {"2531": "澳门地区"},
  "34": {"2532": "台湾全省"}
};

export const ProvinceUtil = [
  {value:"1", label: "北京市"},
  {value:"2", label: "上海市"},
  {value:"3", label: "天津市"},
  {value:"4", label: "重庆市"},
  {value:"5", label: "内蒙古自治区"},
  {value:"6", label: "山西省"},
  {value:"7", label: "河北省"},
  {value:"8", label: "辽宁省"},
  {value:"9", label: "吉林省"},
  {value:"10", label: "黑龙江省"},
  {value:"11", label: "江苏省"},
  {value:"12", label: "安徽省"},
  {value:"13", label: "山东省"},
  {value:"14", label: "浙江省"},
  {value:"15", label: "江西省"},
  {value:"16", label: "福建省"},
  {value:"17", label: "湖南省"},
  {value:"18", label: "湖北省"},
  {value:"19", label: "河南省"},
  {value:"20", label: "广东省"},
  {value:"21", label: "海南省"},
  {value:"22", label: "广西壮族自治区"},
  {value:"23", label: "贵州省"},
  {value:"24", label: "四川省"},
  {value:"25", label: "云南省"},
  {value:"26", label: "陕西省"},
  {value:"27", label: "甘肃省"},
  {value:"28", label: "宁夏回族自治区"},
  {value:"29", label: "青海省"},
  {value:"30", label: "新疆维吾尔自治区"},
  {value:"31", label: "西藏自治区"}
];



// WEBPACK FOOTER //
// ./src/util/cityUtil.ts